import Check from "@mui/icons-material/Check";
import SendIcon from "@mui/icons-material/Send";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Menu from "@mui/joy/Menu";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import "./viewTicket.css";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { DynamicStar } from "react-dynamic-star";
import SimpleBackdrop from "../../../Ui/Loader/backdrop";
import axios from "axios";
import Rating from "@mui/material/Rating";
import { Logger } from "../../../Logger/Logger";
import { Tooltip } from "@mui/material";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFormik } from "formik";
import CustomToaster from "../../../Ui/toaster/CustomToaster";

const initialState = {
  comments: "",
};

const schema = yup.object().shape({
  comments: yup
    .string()
    .required("Please enter the comments for ticket")
    // .matches(/^[a-zA-Z0-9]+[a-zA-Z0-9\.\,\_\ \:\;\"\/\-]*$/, "Should start with character only and special characters are not allowed")
    // .min(3, "Comment length should be between 3 and 1000")
    .trim()
    .min(3, "Comments must be at least 3 characters"),

  // .max(1000, "Comment length should be between 3 and 1000"),
});

const initialState2 = {
  requestType: "",
  category: "",
  subCategory: "",
  severity: "",
  hostName: "",
}

const schema2 = yup.object().shape({
  requestType: yup.string().required("Please select a request type"),
  category: yup.string().required("Please select a category"),
  subCategory: yup.string().required("Please select a sub-category"),
  severity: yup.string().required("Please select a severity level"),
  hostName: yup.string().required("Please enter your notebook name").matches(/^[a-zA-Z0-9]+[a-zA-Z0-9\.\,\_\ \:\;\"\/\-]*$/, "Should start with character only and special characters are not allowed"),
});

const ViewForm = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [data, setData] = useState([]);
  const {
    register,
    formState: { errors },
  } = useForm({
    initialState,
    mode: "onTouched",
    resolver: yupResolver(schema),
  });
  const formik = useFormik({
    initialValues: initialState,
    validationSchema: schema,
    onSubmit: (data) => handleCommentSubmit(data),
  });

  const formik2 = useFormik({
    initialValues: initialState2,
    validationSchema: schema2,
    onSubmit: (data) => handleSubmitForm(data),
  });
  const [fontWeight, setFontWeight] = useState("normal");
  const [anchorEl, setAnchorEl] = useState(null);
  const [commentData, setCommentData] = useState("");
  const [value, setValue] = React.useState("1");
  const [singleViewTiket, setSingleViewTicket] = useState("");
  const { id } = useParams();
  const data2 = JSON.stringify(id).replace(/['{" "}]+/g, "");
  const index = data2.lastIndexOf(":");
  // const valueId = parseInt(data2.substring(index + 1));
  const valueId = Number(data2.substring(index + 1));
  const [openFeedback, setOpenFeedback] = useState(false);
  const [disableComment, setDisableComment] = useState(false);
  const [viewCloseTicket, setViewCloseTicket] = useState(true);
  const [open, setOpen] = useState(false);
  const [tktCreatedBy, setCreatedBy] = useState("");
  const [tktCreated, setTktCreated] = useState("");
  const [allowCloseTicket, setAllowCloseTicket] = useState(false);
  const [feedBackValue, setFeedBackValue] = useState(0);
  const [editFlag, setEditFlag] = useState(false);
  const [hide, setHide] = useState(false);
  const [star, setStar] = useState({
    rating: 3,
    totalStars: 5,
    sharpness: 2.5,
    width: 100,
    height: 100,
    outlined: true,
    outlinedColor: "",
    fullStarColor: "#FFBC00",
    emptyStarColor: "whitesmoke",
  });

  const navigate = useNavigate();
  const [fileData, setFileData] = useState([]);
  const cookies = new Cookies();
  const [disable, setDisable] = useState(false);
  const apiKey = cookies.get("UserLogin");
  const LoggedInUser = cookies.get("UserLogin");
  const UserName = cookies.get("UserDetails");
  const [isAdmin, setIsAdmin] = useState(cookies.get("adminRole") === "true");
  const ticketCreatedBy = cookies.get("createdBy");
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    height: 200,
    border: 0,
    bgcolor: "background.paper",
    borderRadius: 6,
    boxShadow: 24,
    p: 4,
  };
  const [commentError, setCommentError] = useState(true);
  const location = useLocation();
  // const pageNo = location?.state?.pageNumber ?? 0;
  const pageNo = location?.state?.pageNumber;

  //Editable Form
  const [type, setType] = useState("");
  const reqType = ["Incident", "Request"];
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [updateFormData, setUpdateFormData] = useState({
    requestType: "",
    categoryData: "",
    sub_category: "",
    severity: "",
    host_name: "",
  });
  const [requestType, setRequestType] = useState();
  const [severity, setSeverity] = useState();

  const [categoryFlag, setcategoryFlag] = useState(false);
  const [subcategoryFlag, setsubcategoryFlag] = useState(false);
  const [toaster, setToaster] = useState(false);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [variant, setVariant] = useState("");

  const queryParams = {
    id: updateFormData.categoryData,
  };
  const params = new URLSearchParams(queryParams);
  useEffect(() => {
    getTicketData();
  }, [valueId, openFeedback, editFlag]);


  useEffect(() => {
    if (updateFormData.categoryData !== "") {
      axios
        .get(`${BASE_URL}api/ticket/sub_categories/?${params}`, {
          headers: { Authorization: `Bearer ${apiKey}` },
        })
        .then((res) => {
          Logger.debug("subcategories", res.data.data);
          setSubCategory(res.data.data);
        })
        .catch((error) => {
          if (error.response.status == 403) {
            cookies.remove("UserLogin");
            cookies.remove("UserDetails");
            cookies.remove("adminRole");
            cookies.remove("sysAdminRole");
            cookies.remove("createdBy");
            cookies.remove("UserLoginAccessToken");
            cookies.remove("UserName");
            navigate("/");
          }
          if (error.response.status == 404) {
            navigate("/*");
            setTimeout(() => {
              navigate("/secured/empDashboard");
            }, 5000);
          }
        });
    }
  }, [updateFormData]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}api/ticket/categories/`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        Logger.debug("Response at ticketCategoriesList", res.data.data);
        Logger.debug(
          "res at ticketCategoriesList",
          res.data.data[type].categories
        );
        setCategory([...res.data.data[type].categories]);
      })
      .catch((error) => {
        if (error.response?.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response?.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });

  }, [type]);


  useEffect(() => {
    console.log("Locationnnnnnnn", location)
    getComments();
  }, [valueId]);



  useEffect(() => {
    Logger.debug("SINGLE VIEW TICKET", singleViewTiket)
    Logger.debug("Category data", category)

  }, [type, editFlag, updateFormData])

  const handleSubmitForm = (data) => {
    Logger.debug("FORM DATA in handleSubmitForm", data);
    Logger.debug("Object DATA in handleSubmitForm", updateFormData);
    let temp = {
      requestType: data.requestType,
      categoryData: data.category,
      sub_category: data.subCategory,
      severity: data.severity,
      host_name: data.hostName,
    }
    Logger.debug("Form Temp Data", temp)
    if (data) {
      setOpen(true);
      axios
        .patch(`${BASE_URL}api/ticket/${valueId}/`, { ...temp }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
          },
        })
        .then((response) => {
          Logger.error("response list", response);
          setEditFlag(false);
          setOpen(false);
          setToaster(true);
          setTitle("Success");
          setVariant("success");
          setSubTitle(
            `Ticket has been successfully updated.`
          );
          setTimeout(() => {
            setToaster(false);
            navigate("/secured/ticketList");
          }, 2000);
        })
        .catch((error) => {
          Logger.error("comment list", error);
          if (error.response.status == 403) {
            cookies.remove("UserLogin");
            cookies.remove("UserDetails");
            cookies.remove("adminRole");
            cookies.remove("sysAdminRole");
            cookies.remove("createdBy");
            cookies.remove("UserLoginAccessToken");
            cookies.remove("UserName");
            navigate("/");
          }
          if (error.response.status == 404) {
            navigate("/*");
            setTimeout(() => {
              navigate("/secured/empDashboard");
            }, 5000);
          }
        });
    }
  }

  const CategoryHandleChange = (e) => {
    Logger.debug("RRRRRR", e);
    setUpdateFormData({
      ...updateFormData,
      categoryData: e.target.value,
    });
  };

  const subCategoryDataHandleChange = (e) => {
    Logger.debug("EVENT", e);
    setUpdateFormData({
      ...updateFormData,
      sub_category: e.target.value,
    });
  };

  const handleData = (e) => {
    setData(e.target.value);
  };

  Logger.debug("isAdmin", cookies.get("adminRole"));
  const getComments = () => {
    // TicketServices.ticketCommentsGetList(valueId)
    axios
      .get(`${BASE_URL}api/ticket/comments/get_list/${valueId}`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        Logger.debug("res at getComments", res);
        setCommentData(res.data.data);
      })
      .catch((error) => {
        Logger.error("comment list", error);
        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  };



  const handleCommentSubmit = (dat) => {
    // const regex = "^\d*[a-zA-Z][a-zA-Z0-9]*$";
    if (dat) {
      // if (data.length >= 3 && data != "" && data.match(/^[a-zA-Z0-9]/)) {
      // setCommentError(false);
      setOpen(true);

      let comment_data = {
        comment: data,
        comment_user_name: UserName,
        ticket: valueId,
      };
      axios
        .post(`${BASE_URL}api/ticket/comments/`, comment_data, {
          headers: { Authorization: `Bearer ${apiKey}` },
        })

        .then((res) => {
          getComments();
          setData([]);
          formik.setFieldValue("comments", "");
          setCommentError(false);
          setDisable(false);
          setOpen(false);
          Logger.debug(" ticketCommentsCreate res", res);
        })
        .catch((error) => {
          Logger.error("create comment", error);
          if (error.response.status == 403) {
            cookies.remove("UserLogin");
            cookies.remove("UserDetails");
            cookies.remove("adminRole");
            cookies.remove("sysAdminRole");
            cookies.remove("createdBy");
            cookies.remove("UserLoginAccessToken");
            cookies.remove("UserName");
            navigate("/");
          }
          if (error.response.status == 404) {
            navigate("/*");
            setTimeout(() => {
              navigate("/secured/empDashboard");
            }, 5000);
          }
        });
    }
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleFeedbackSubmit = (e) => {
    setHide(true);
    setOpen(true);
    setOpenFeedback(false);
    setViewCloseTicket(false);
    setOpen(false);
    setAllowCloseTicket(false);

    const lastFeed = {
      feedback: value,
    };
    Logger.debug("feedback ticket..", value);

    Logger.info("feedback ticket..", lastFeed.feedback);
    // setOpenFeedback(true);
    axios
      .patch(`${BASE_URL}api/ticket/add_feedback/${valueId}/`, lastFeed, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        Logger.debug("res at close ticket", res);
        Logger.info("res at close ticket", res);

        navigate("/secured/ticketList");
      })
      .catch((error) => {
        Logger.error("error in add feedback", error);
        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });

    Logger.debug("EEEe", e);
  };

  const handleFloatValue = (e, property) => {
    Logger.debug("rating", e.target.value);
    setFeedBackValue(e.target.value);
    const float = e.target.value.replace(/,/g, ".");
    setStar((prev) => ({ ...prev, [property]: float }));
  };



  const getTicketData = () => {
    axios
      .get(`${BASE_URL}api/ticket/${valueId}`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        Logger.debug("ticketRead view ", res);
        let tktCrt = res.data.data.created_by.split(/[.@]/);
        let tktCrtStr = tktCrt[0].charAt(0).toUpperCase() + tktCrt[0].slice(1) + " " + tktCrt[1].charAt(0).toUpperCase() + tktCrt[1].slice(1)
        setTktCreated(tktCrtStr)
        setSingleViewTicket(res.data.data);

        let val = reqType.indexOf(res.data.data.incident_type)
        Logger.debug("VALUE of REquest type", val)
        setType(val)
        setcategoryFlag(true)
        formik2.setFieldValue("requestType", val)
        setCreatedBy(res.data.data.created_by);
        Logger.debug("res.data.data.attachments", res.data.data.attachments);
        setFileData([...res.data.data.attachments]);
        ticketCreatedBy === tktCreatedBy
          ? setAllowCloseTicket(true)
          : setAllowCloseTicket(false);
      })
      .catch((error) => {
        Logger.debug("ERROR", error)
        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  }

  const handleClose = () => {
    setOpenFeedback(false);
  };
  const handleCloseTicket = () => {
    const lastFeed = {
      feedback: feedBackValue,
    };

    setDisable(true);
    setOpen(true);
    axios
      .patch(`${BASE_URL}api/ticket/close_ticket/${valueId}/`, lastFeed, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        Logger.debug("res at close ticket", res);
        setOpen(false);
        setDisable(false);
        setTimeout(() => {
          navigate("/secured/ticketList");
        }, 500);
      })
      .catch((error) => {
        Logger.error("Error in close ticket", error);
        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  };

  const donwloadData = (data) => {
    axios
      .get(`${BASE_URL}api/ticket/attachment/${data.id}/`, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
          // "Content-Type": "image/png",
        },
      })
      // .then((response) => response.blob())
      // .then((blob) => {

      //   // 2. Create blob link to download
      //   const url = window.URL.createObjectURL(new Blob([blob]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', `sample`);
      //   // 3. Append to html page
      //   document.body.appendChild(link);
      //   // 4. Force download
      //   link.click();
      //   // 5. Clean up and remove the link
      //   link.parentNode.removeChild(link);
      //   this.setState({
      //     loading: false
      //   });
      // })
      .then((res) => {
        Logger.debug("success", res);
        exportAnyFile(res, data.attachment);
      })

      .catch((error) => Logger.debug("error", error));
  };

  function exportAnyFile(response, fileName) {
    Logger.debug("response of download data", response);
    const a = document.createElement("a");

    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: response.data.type })
    );

    a.href = url;

    a.download = fileName || "Document.pdf";

    document.body.append(a);

    a.click();

    a.remove();

    window.URL.revokeObjectURL(url);
  }

  const handleEditButton = () => {
    setEditFlag(true);
    Logger.debug("SingleViewTicket", singleViewTiket)

    formik2.setFieldValue("severity", singleViewTiket.severity)

    formik2.setFieldValue("hostName", singleViewTiket.host_name)

    Logger.debug("Category data", category)
    let catVal = category.filter((cat) => cat.name == singleViewTiket.category)
    Logger.debug("catVal", catVal[0].id)
    

    setUpdateFormData({
      ...updateFormData,
      categoryData: catVal[0].id,
    })
    formik2.setFieldValue("category", catVal[0].id)
    setsubcategoryFlag(true);
    formik2.setFieldValue("subCategory", singleViewTiket?.sub_category)

  }

  return (
    <div className="viewTicketContainer">
      <div className="viewWrapper">
        <form className="viewTicket" onSubmit={formik2.handleSubmit}>
          <div
            className="back_main"
            onClick={() => {
              if (pageNo !== undefined) {
                navigate("/secured/ticketList", { state: { tktId: singleViewTiket.id, pageN: pageNo }, })
              }
              else {
                window.history.back()
              }
            }}
          >
            <div className="backBtn">Back</div>
            <div className="back_span"></div>
          </div>
          <div className="ticketName">
            <div>
              Ticket No. {singleViewTiket.id}
            </div>
            <div>Created by :- {tktCreated}</div>
          </div>
          <div className="viewTicketMain">
            {!editFlag ? <>
              <div className="viewmain">
                <label htmlFor="Incident Type" className="view_label">
                  Incident Type
                </label>
                <TextField
                  className="view_input_text"
                  size="small"
                  id="standard-read-only-input"
                  name="incidentType"
                  fullWidth
                  value={singleViewTiket ? singleViewTiket.incident_type : ""}
                  autoComplete="incident type"
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </div>
              <div className="viewmain">
                <label className="view_label">Category</label>

                <TextField
                  size="small"
                  id="standard-read-only-input"
                  name="category"
                  fullWidth
                  autoComplete="category"
                  InputProps={{
                    readOnly: true,
                  }}
                  value={singleViewTiket ? singleViewTiket.category : ""}
                />
              </div>
              <div className="viewmain">
                <label className="view_label">Subcategory</label>

                <TextField
                  size="small"
                  id="standard-read-only-input"
                  name="subCategory"
                  fullWidth
                  autoComplete="sub category"
                  InputProps={{
                    readOnly: true,
                  }}
                  value={singleViewTiket ? singleViewTiket.sub_category_name : ""}
                />
              </div>
              <div className="viewmain">
                <label className="view_label">Severity</label>

                <TextField
                  size="small"
                  id="standard-read-only-input"
                  name="severity"
                  fullWidth
                  autoComplete="severity"
                  InputProps={{
                    readOnly: true,
                  }}
                  value={singleViewTiket ? singleViewTiket.severity : ""}
                />
              </div>
              <div className="viewmain">
                <label className="view_label">NoteBook Name</label>

                <TextField
                  size="small"
                  id="standard-read-only-input"
                  name="ticketNumber"
                  fullWidth
                  value={singleViewTiket ? singleViewTiket.host_name : ""}
                  autoComplete="ticket number"
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </div>
              <div className="viewmain">
                <label className="view_label">Created date</label>

                <TextField
                  size="small"
                  id="standard-read-only-input"
                  name="createdAt"
                  fullWidth
                  autoComplete="created date"
                  InputProps={{
                    readOnly: true,
                  }}
                  value={
                    singleViewTiket
                      ? new Date(singleViewTiket.created_date)
                        .toLocaleString()
                        .split(",")[0]
                      : ""
                  }
                />
              </div>
            </> : <>
              {/* Editable Form */}
              <div className="viewmain">
                <label htmlFor="Incident Type" className="view_label">
                  Incident Type *
                </label>
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  select
                  size="small"
                  style={{ width: "100%" }}
                  name="requestType"
                  value={updateFormData.requestType}
                  // {...register("requestType")}
                  error={
                    formik2.touched.requestType &&
                    Boolean(formik2.errors.requestType)
                  }
                  helperText={
                    !formik2.errors.requestType
                      ? " "
                      : formik2.errors.requestType
                  }
                  {...formik2.getFieldProps("requestType")}
                  SelectProps={{
                    displayEmpty: true,
                    renderValue: (value) => {
                      if (value !== "") {
                        return reqType[value];
                      } else {
                        return (
                          <span className="dropdown_placeholder">
                            Select ticket type
                          </span>
                        );
                      }
                    },
                  }}
                  onChange={(e) => {
                    Logger.debug("EVENT", e.target.value);
                    formik2.handleChange(e);
                    setUpdateFormData({
                      ...updateFormData,
                      requestType: e.target.value,
                    });
                    formik2.setFieldValue("category", "");
                    formik2.setFieldValue("subCategory", "");
                    setType(Number(e.target.value));
                    setcategoryFlag(true);
                    setsubcategoryFlag(false);
                  }}
                >
                  {reqType.map((req, index) => {
                    return (
                      <MenuItem key={index} value={index}>
                        {req}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </div>
              <div className="viewmain">
                <label className="view_label">Category *</label>

                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  select
                  size="small"
                  style={{ width: "100%" }}
                  name="categoryData"
                  value={updateFormData.categoryData}
                  // {...register("category")}
                  error={
                    formik2.touched.category && Boolean(formik2.errors.category)
                  }
                  disabled={!categoryFlag ? true : false}
                  helperText={
                    !formik2.errors.category ? " " : formik2.errors.category
                  }
                  {...formik2.getFieldProps("category")}
                  SelectProps={{
                    displayEmpty: true,
                    renderValue: (value) => {
                      if (value !== "") {
                        return category.find((item) => item.id == value)?.name;
                      } else {
                        return (
                          <span className="dropdown_placeholder">
                            Select ticket category
                          </span>
                        );
                      }
                    },
                  }}
                  onChange={(e) => {
                    formik2.handleChange(e);
                    CategoryHandleChange(e);
                    formik2.setFieldValue("subCategory", "");
                    setsubcategoryFlag(true)
                  }}
                >
                  {category.map((caterogryList) => {
                    return (
                      <MenuItem
                        key={caterogryList.id}
                        value={caterogryList.id}
                      >
                        {caterogryList.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </div>
              <div className="viewmain">
                <label className="view_label">Subcategory *</label>

                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  select
                  size="small"
                  style={{ width: "100%" }}
                  name="sub_category"
                  value={updateFormData.sub_category}
                  {...register("subCategory")}
                  error={
                    formik2.touched.subCategory &&
                    Boolean(formik2.errors.subCategory)
                  }
                  disabled={!subcategoryFlag ? true : false}
                  helperText={
                    !formik2.errors.subCategory
                      ? " "
                      : formik2.errors.subCategory
                  }
                  {...formik2.getFieldProps("subCategory")}
                  SelectProps={{
                    displayEmpty: true,
                    renderValue: (value) => {
                      if (value !== "") {
                        return subCategory.find((item) => item.id == value)
                          ?.name;
                      } else {
                        return (
                          <span className="dropdown_placeholder">
                            Select ticket sub-category
                          </span>
                        );
                      }
                    },
                  }}
                  onChange={(e) => {
                    formik2.handleChange(e);
                    subCategoryDataHandleChange(e);
                  }}
                >
                  {subCategory.map((val) => {
                    return (
                      <MenuItem key={val.id} value={val.id}>
                        {val.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </div>
              <div className="viewmain">
                <label className="view_label">Severity *</label>

                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  select
                  size="small"
                  style={{ width: "100%" }}
                  name="severity"
                  value={updateFormData.severity}
                  // {...register("severity")}
                  error={
                    formik2.touched.severity && Boolean(formik2.errors.severity)
                  }
                  helperText={
                    !formik2.errors.severity ? " " : formik2.errors.severity
                  }
                  {...formik2.getFieldProps("severity")}
                  SelectProps={{
                    displayEmpty: true,
                    renderValue: (value) => {
                      if (value !== "") {
                        return value;
                      } else {
                        return (
                          <span className="dropdown_placeholder">
                            Select ticket severity
                          </span>
                        );
                      }
                    },
                  }}
                  onChange={(e) => {
                    formik2.handleChange(e);
                    setUpdateFormData({
                      ...updateFormData,
                      severity: e.target.value,
                    });
                  }}
                >
                  <MenuItem value={"High"}>High</MenuItem>
                  <MenuItem value={"Medium"}>Medium</MenuItem>
                  <MenuItem value={"Low"}>Low</MenuItem>
                </TextField>
              </div>
              <div className="viewmain">
                <label className="view_label">NoteBook Name *</label>

                <TextField
                  id="outlined-basic"
                  autoComplete="off"
                  variant="outlined"
                  type="text"
                  size="small"
                  style={{ width: "100%" }}
                  name="host_name"
                  placeholder="eg.(NB-22-097)"
                  sx={{
                    input: {
                      "&::placeholder": {
                        fontSize: "14px",
                        fontFamily: "Arial, Helvetica, sans-serif !important",
                        opacity: 0.5,
                      },
                    },
                  }}
                  value={updateFormData.host_name}
                  // {...register("hostName")}
                  error={
                    formik2.touched.hostName && Boolean(formik2.errors.hostName)
                  }
                  helperText={
                    !formik2.errors.hostName ? " " : formik2.errors.hostName
                  }
                  {...formik2.getFieldProps("hostName")}
                  onChange={(e) => {
                    formik2.handleChange(e);
                    setUpdateFormData({
                      ...updateFormData,
                      host_name: e.target.value,
                    });
                  }}
                />
              </div>


              <div className="viewmain">
                <label className="view_label">Created date</label>

                <TextField
                  size="small"
                  id="standard-read-only-input"
                  name="createdAt"
                  fullWidth
                  autoComplete="created date"
                  InputProps={{
                    readOnly: true,
                  }}
                  value={
                    singleViewTiket
                      ? new Date(singleViewTiket.created_date)
                        .toLocaleString()
                        .split(",")[0]
                      : ""
                  }
                />
              </div>
            </>}

            <div className="viewmain width">
              <label className="view_label">Subject</label>

              <TextField
                size="small"
                id="standard-read-only-input"
                name="subject"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
                value={singleViewTiket ? singleViewTiket.subject : ""}
              />
            </div>

            <div className="viewmain width">
              <label className="view_label">Description</label>

              <TextField
                size="small"
                id="standard-read-only-input"
                multiline
                // maxRows="8"
                name="description"
                fullWidth
                autoComplete="ticket description"
                InputProps={{
                  readOnly: true,
                }}
                value={singleViewTiket ? singleViewTiket.description : ""}
              />
            </div>
            <div className="viewmain">
              <label className="view_label">Assigned to</label>

              <TextField
                size="small"
                id="standard-read-only-input"
                name="assignedTo"
                fullWidth
                autoComplete="assigned to"
                InputProps={{
                  readOnly: true,
                }}
                value={singleViewTiket ? singleViewTiket.assigned_to : ""}
              />
            </div>

            <div className="viewmain">
              <label className="view_label">Status</label>

              <TextField
                size="small"
                id="standard-read-only-input"
                name="status"
                fullWidth
                autoComplete="status"
                InputProps={{
                  readOnly: true,
                }}
                value={singleViewTiket ? singleViewTiket.status : ""}
              />
            </div>

            <div className="viewmain width">
              <label className="view_label">Watchers</label>

              <TextField
                size="small"
                id="standard-read-only-input"
                multiline
                rows="2"
                name="managerEmail"
                fullWidth
                autoComplete="manager email"
                InputProps={{
                  readOnly: true,
                }}
                value={
                  singleViewTiket
                    ? singleViewTiket.managers.length > 0
                      ? singleViewTiket.managers
                      : "No watchers added"
                    : ""
                }
              />
            </div>

            <div className="viewmain file_names">
              <label className="view_label">Files</label>

              <div>
                {fileData.map((item) => {
                  return (
                    <div className="file_data">
                      <h2 className="file_namesH2">{item.attachment}</h2>
                      <a
                        href={`${BASE_URL}api/ticket/attachment/${item.id}/`}
                        className="!pt-[0px]"
                      >
                        <img
                          src="/Images/download.svg"
                          alt=""
                          className="!max-w-none"
                        />
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="flex py-[13px]">
            {(singleViewTiket.status === "In Progress" || singleViewTiket.status === "Open") &&
              (cookies.get("sysAdminRole") == "true" || cookies.get("adminRole") == "true") ?
              (!editFlag ?
                <Button
                  className="close_btn"
                  variant="contained"
                  color="error"
                  disabled={disable}
                  // onClick={handleCloseTicket}
                  onClick={() => handleEditButton()}
                >
                  Edit Ticket
                </Button>
                :
                <div className="flex flex-row ">
                  <Button
                    type="submit"
                    color="error"
                    // disabled={disable}
                    className="close_btn"
                    variant="contained"
                  // onClick={handleCloseTicket}
                  // onClick={()=> setEditFlag(true)}
                  >
                    Update Ticket
                  </Button>
                  <Button
                    // color="error"
                    // disabled={disable}
                    className="!ml-[20px]"
                    sx={{
                      textTransform: "capitalize",
                      borderRadius: 1,
                      color: "#F05E67",
                      border: "1px solid #F05E67",
                      "&:hover": {
                        color: "#F05E67",
                        backgroundColor: "#fff",
                        border: "1px solid #F05E67",
                        // opacity: 0.7
                      },
                    }}
                    onClick={() => setEditFlag(false)}
                  >
                    Cancel
                  </Button>
                </div>
              ) : (
                ""
              )}
            {singleViewTiket.status === "Resolved" &&
              (cookies.get("sysAdminRole") == "true" ||
                cookies.get("adminRole") == "true") ? (
              <Button
                className="close_btn"
                variant="contained"
                color="error"
                disabled={disable}
                onClick={handleCloseTicket}
              >
                Close Ticket
              </Button>
            ) : (
              ""
            )}
            {singleViewTiket.status === "Closed" &&
              singleViewTiket.feedback <= 0 &&
              cookies.get("adminRole") == "false" ? (
              <Button
                className="close_btn"
                variant="contained"
                color="error"
                onClick={() => setOpenFeedback(true)}
              >
                Feedback
              </Button>
            ) : (
              ""
            )}
          </div>
          {openFeedback ? (
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={openFeedback}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={openFeedback}>
                <Box sx={style}>
                  <Box
                    sx={{ minWidth: 120 }}
                    className="flex flex-col items-center"
                  >
                    <h1 className="mb-[20px] text-center text-xl">Feedback</h1>

                    <Rating
                      size="large"
                      name="simple-controlled"
                      value={value}
                      onChange={(event, newValue) => {
                        setValue(newValue);
                      }}
                    />
                  </Box>
                  <Button
                    variant="contained"
                    className="!bg-[#05374F]"
                    sx={{ position: "absolute", bottom: 20, right: 20 }}
                    onClick={handleFeedbackSubmit}
                  >
                    Submit
                  </Button>
                </Box>
              </Fade>
            </Modal>
          ) : (
            ""
          )}
        </form>

        <div className="viewComment">
          <div>
            <div className="commentsContainer">
              <div
                style={{
                  overflowY: "scroll",
                  maxHeight: "60vh",
                  width: "100%",
                }}
              >
                {commentData &&
                  commentData.map((e) => {
                    Logger.debug("e", e);
                    return (
                      <div>
                        <div>
                          <div className="comment_header">
                            <h2 className="commenter_name">
                              {e.comment_user_name}
                            </h2>{" "}
                            <Tooltip
                              title={
                                new Date(e.commented_date)
                                  .toLocaleString()
                                  .split(",")[1]
                              }
                            >
                              <span className="view_date">
                                <i>
                                  {" "}
                                  {
                                    new Date(e.commented_date)
                                      .toLocaleString()
                                      .split(",")[0]
                                  }
                                </i>
                              </span>
                            </Tooltip>
                          </div>

                          <div className="comment_desc"><pre>{e.comment}</pre></div>
                          <hr style={{ width: "95%" }} />
                        </div>
                      </div>
                    );
                  })}
              </div>
              <br />
            </div>
            <form onSubmit={formik.handleSubmit} className="textFieldComment">
              {/* <FormControl className="yourComment"> */}
              <TextField
                multiline
                rows={4}
                // id="outlined-basic"
                autoComplete="off"
                // value={data}
                // onChange={handleData}
                // className="comment_outline"
                sx={{
                  "& fieldset": { border: "none" },
                }}
                placeholder="Please comment here…"
                endDecorator={
                  <Box
                    sx={{
                      display: "flex",

                      flex: "auto",
                    }}
                  >
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={() => setAnchorEl(null)}
                      size="sm"
                      placement="bottom-start"
                      sx={{ "--List-decorator-size": "24px" }}
                    >
                      {["200", "normal", "bold"].map((weight) => (
                        <MenuItem
                          key={weight}
                          selected={fontWeight === weight}
                          onClick={() => {
                            setFontWeight(weight);
                            setAnchorEl(null);
                          }}
                          sx={{ fontWeight: weight }}
                        >
                          <ListItemDecorator>
                            {fontWeight === weight && <Check fontSize="sm" />}
                          </ListItemDecorator>
                          {weight === "200" ? "lighter" : weight}
                        </MenuItem>
                      ))}
                    </Menu>
                    {/* {<p className={(data == "" || data.length < 3) && commentError ? "comment_error" : "comment_error invisible"}>Comment should not be less than 3 characters</p>} */}
                    {/* <div className="comment_btn">

                        <button
                          type="submit"
                        // onClick={() => {
                        //   handleCommentSubmit();
                        // }}
                        >
                          <Tooltip title="Send">
                            <SendIcon sx={{ color: "#F05E67" }} />
                          </Tooltip>
                        </button>
                      </div> */}
                  </Box>
                }
                value={data}
                error={
                  formik.touched.comments && Boolean(formik.errors.comments)
                }
                // helperText={
                //   !formik.errors.comments ? " " : formik.errors.comments
                // }
                {...formik.getFieldProps("comments")}
                onChange={(e) => {
                  formik.handleChange(e);
                  handleData(e);
                }}
              />
              {/* </FormControl> */}
              <div className="comment_btn">
                {
                  <p
                    className={
                      commentError && formik.errors.comments
                        ? "comment_error"
                        : "invisible"
                    }
                  >
                    {formik.errors.comments ? formik.errors.comments : " "}
                  </p>
                }
                <button
                  type="submit"
                // onClick={() => {
                //   handleCommentSubmit();
                // }}
                >
                  <Tooltip title="Send Comment">
                    <SendIcon sx={{ color: "#F05E67" }} />
                  </Tooltip>
                </button>
              </div>
            </form>
            {singleViewTiket.status === "Closed" &&
              singleViewTiket.feedback > 0 ? (
              <div className="ratings">
                <Typography component="legend" className="feedback_name">
                  Feedback
                </Typography>
                <Rating
                  size="large"
                  name="read-only"
                  value={String(singleViewTiket.feedback)}
                  readOnly
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {toaster ? (
        <CustomToaster
          title={title}
          subTitle={subTitle}
          variant={variant}
        ></CustomToaster>
      ) : (
        <></>
      )}
      {open ? (
        <SimpleBackdrop open={open} setOpen={setOpen}></SimpleBackdrop>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ViewForm;
